import { useLocation } from 'react-router-dom';

import type { UpgradePromoBannerProps } from '../ui/UpgradePromoBanner';
import { useUpgradePromoActions } from './useUpgradePromoActions';
import { useUpgradeTrigger } from './useUpgradeTrigger';

// Routes under `/app/billing/subscription*` already surface plan selection; a
// banner pointing back to the same flow is redundant noise (CL-6382).
const SUBSCRIPTION_ROUTE_PREFIX = '/app/billing/subscription';

/**
 * Banner-variant props for the upgrade-plan promo. Returns null when the user
 * is ineligible, the chosen layout isn't `banner`, or the current route is a
 * subscription page. The layout (`2Pane`) uses null as the signal to fall
 * through to other promo candidates.
 */
export const useUpgradePromoBannerProps = (): UpgradePromoBannerProps | null => {
  const decision = useUpgradeTrigger();
  const actions = useUpgradePromoActions(decision);
  const { pathname } = useLocation();

  if (!decision.eligible || decision.layout !== 'banner') return null;
  if (pathname.startsWith(SUBSCRIPTION_ROUTE_PREFIX)) return null;
  if (!actions) return null;

  return {
    pitch: decision.pitch,
    onCta: actions.onCta,
    onDismiss: actions.onDismiss,
  };
};
